import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgElement3 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.16474 0.200726L3.97495 0.0262507C3.32512 -0.0691273 2.66402 0.097656 2.137 0.489808L1.17232 1.20771C0.645566 1.59973 0.295976 2.1852 0.200726 2.83503L0.0262507 4.02482C-0.0691273 4.67464 0.097656 5.33575 0.489808 5.86277L1.20771 6.82744C1.59986 7.35433 2.1852 7.70392 2.83503 7.7993L4.02482 7.97377C4.67464 8.06915 5.33575 7.90237 5.86277 7.51022L6.82744 6.79232C7.35433 6.40017 7.70392 5.81482 7.7993 5.165L7.97377 3.97521C8.06915 3.32538 7.90237 2.66427 7.51022 2.13726L6.79232 1.17258C6.40017 0.645695 5.81482 0.296104 5.165 0.200726H5.16474Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgElement3);
export default ForwardRef;
